import React from "react";

function BottomBorder({ className, children }) {
  return (
    <div className={`border-subtle border-b ${className}`}>{children}</div>
  );
}

export default BottomBorder;
